import {call, delay, put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    IMPERSONATE_ADMIN_PROXY_FAILURE,
    IMPERSONATE_ADMIN_PROXY_SUCCESS,
    TERMINATE_ADMIN_PROXY_FAILURE,
    TERMINATE_ADMIN_PROXY_SUCCESS,
} from 'src/pages/admin/redux/action/actionTypes.js';
import { getBannerDetails } from 'src/common/redux/sagas/hybrisBannerDetails';

export function* adminImpersonateProxy(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/impersonation/impersonate`;
    try {
        const result = yield axios({
            method: 'post',
            url: url,
            headers: {
                PrincipalUser: action.payload.networkIdName,
            },
        }).then((response) => response.data);
        sessionStorage.setItem(
            'ProxyUser',
            action.payload.firstName + ' ' + action.payload.lastName
        );
        sessionStorage.removeItem('impersonationEndFlag');
        sessionStorage.setItem('ProxyUserRole', action.payload.userRoles);
        // sessionStorage.setItem(
        //     'ProxyimpersonationKey',
        //     result.impersonationKey
        // );
        sessionStorage.setItem('impersonationFlag', true);
        sessionStorage.setItem('impersonationKey', result.impersonationKey);

        yield put({ type: IMPERSONATE_ADMIN_PROXY_SUCCESS, payload: result });
        yield delay(100);
        yield call(getBannerDetails);

    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: IMPERSONATE_ADMIN_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* terminateProxy() {

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/impersonation/invalidate`;
    try {
        const result = yield axios.post(url).then((response) => response.data);
        yield put({ type: TERMINATE_ADMIN_PROXY_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url
        });
        yield put({
            type: TERMINATE_ADMIN_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
